import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  messages: [],
  unreadCount: 0,
  messagesUnreadCount: 0,
};

const notificationSlice = createSlice({
  name: 'notificationValues',
  initialState,
  reducers: {
    receive(state,action) {
      const existingMessagesSet = new Set(state.messages.map((message) => `${message.notificationId}`));

      action.payload.messages.forEach((data) => {
        const messageKey = `${data.notificationId}`;
        if (!existingMessagesSet.has(messageKey)) {
          state.messages.unshift(data);
          existingMessagesSet.add(messageKey);
          state.unreadCount += 1;
        }
      });
    },
    receiveAll(state,action) {
      state.messages = action.payload.messages || [];
      if (Object.prototype.hasOwnProperty.call(action.payload, 'unreadCount')) {
        state.unreadCount = action.payload.unreadCount;
      }
      if (Object.prototype.hasOwnProperty.call(action.payload, 'messagesUnreadCount')) {
        state.messagesUnreadCount = action.payload.messagesUnreadCount;
      }
    },
    setMessagesUnreadCount(state, action) {
      state.messagesUnreadCount = typeof action.payload === 'number'
        ? action.payload
        : state.messagesUnreadCount;
    },
    reset(state){
      state.messages = [];
      state.unreadCount = 0;
      state.messagesUnreadCount = 0;
    },
    readAll(state) {
      state.messages = state.messages.map((message) => ({
        ...message,
        isRead: true,
      }));
      state.unreadCount = 0;
    },
    readOne(state,action) {
      let decremented = false;
      state.messages = state.messages.map((message) => {
        if (message.notificationId === action.payload.notificationId) {
          if (!message.isRead) {
            decremented = true;
          }
          return {
            ...message,
            isRead: true,
          };
        }
        return { ...message };
      });
      if (decremented) {
        state.unreadCount = Math.max(0, (state.unreadCount || 0) - 1);
      }
    },
  },
});

export const { receive, readAll, reset, receiveAll, readOne, setMessagesUnreadCount } = notificationSlice.actions;
export default notificationSlice.reducer;